import { defineMessages } from 'react-intl-next';

export default defineMessages({
	description: {
		id: 'project-pages.connect-space-dialog.content.space-or-page-selector.description',
		defaultMessage: 'Choose a space or page to connect to your project.',
		description:
			'Description of the modal dialog to link a Confluence space or page to a Jira project',
	},
	placeholder: {
		id: 'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder',
		defaultMessage: 'Search Confluence',
		description: 'Placeholder to search a space or a page in Confluence to link to a Jira project',
	},
	'disconnected-templates-description': {
		id: 'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description',
		defaultMessage:
			'This project needs to be connected to a space before you can create a page. Choose a space to connect to this project.',
		description: '',
	},
});
